module.exports = __webpack_public_path__ + "img/board1-GPX-yellow-52-thumb.19e9eebd.jpg";